<div class="dialog search-focus-edit-dialog">
  <div
    mat-dialog-title
    class="modal-header"
  >
    <h1 class="modal-title">
      <span>
        {{ 'TRANS__FOCUS__EDIT__TITLE_EDIT' | translate }}
      </span>
    </h1>
  </div>

  <div
    mat-dialog-content
    class="modal-body modal-body-edit-fields"
  >
    <div class="modal-main-content">
      <div class="search-focus-edit-dialog__field">
        <span class="search-focus-edit-dialog__field-title">
          <span class="search-focus-edit-dialog__field-title-text">
            {{ 'TRANS__FOCUS__INPUT_FOCUS_NAME' | translate }}
          </span>

          <span class="search-focus-edit-dialog__field-title-required">
            <span>
              *
            </span>
          </span>
        </span>

        <div class="search-focus-edit-dialog__field-content">
          <div class="clearInputContainer">
            <label>
              <input
                type="text"
                [(ngModel)]="data.storedSearchNameQuery"
                [ngClass]="{'errorInputFrame': validateCurrentAndAddNewName() && validateError}"
                autocomplete="off"
              >
            </label>

            @if (data.storedSearchNameQuery) {
              <a
                class="clearInputField"
                (click)="clearNameInput()"
              >
                <mat-icon>
                  close
                </mat-icon>
              </a>
            }
          </div>
        </div>

        @if (validateCurrentAndAddNewName() && validateError) {
          <span class="search-focus-edit-dialog__error">
            <span class="search-focus-edit-dialog__error-text">
              <span>
                {{ validateError | translate }}
              </span>
            </span>
          </span>
        }
      </div>

      <div class="search-focus-edit-dialog__field large-checkbox">
        <mat-checkbox
          [(ngModel)]="data.storedSearchInEdit.stored_search.isDefault"
          (ngModelChange)="toggleIsDefault(data.storedSearchInEdit)"
          [checked]="data.storedSearchInEdit.stored_search.isDefault"
        >
           <span>
             {{ 'TRANS__FOCUS__IS_DEFAULT_TITLE' | translate }}
           </span>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div
    mat-dialog-actions
    class="modal-footer"
  >
    <button
      type="submit"
      mat-flat-button
      color="accent"
      [disabled]="validateCurrentAndAddNewName()"
      (click)="saveStoredSearch()"
    >
      <span class="bold">
        {{ 'TRANS__FOCUS__EDIT__SAVE' | translate }}
      </span>
    </button>

    <button
      type="button"
      mat-button
      color="accent"
      (click)="dialogRef.close(false)"
    >
      <span class="bold">
        {{ 'TRANS__FOCUS__EDIT__CANCEL' | translate }}
      </span>
    </button>
  </div>
</div>
